// @flow

import * as React from 'react';

type Props = {
  visible: boolean,
  children: ({
    visible: boolean,
    onToggleVisibility: () => mixed,
  }) => React.Node,
};

type State = {
  visible: boolean,
};

export default class ModalController extends React.Component<Props, State> {
  static defaultProps = {
    visible: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      visible: props.visible,
    };
  }

  onToggleVisibility = () => {
    this.setState(state => ({
      visible: !state.visible,
    }));
  };

  render() {
    return this.props.children({
      visible: this.state.visible,
      onToggleVisibility: this.onToggleVisibility,
    });
  }
}
